import React, { useEffect, useState } from 'react';
import { SaveBudgetUnitType, GetBudgetUnitTypes, SetBudgetUnitTypeActive, SetBudgetUnitTypeOrder } from '../API/Budget';
import { Button, ListGroup, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faChevronUp, faChevronDown, faCheckDouble, faCheck, faBan } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

export default props => {
    const [units, setUnits] = useState([]);
    const [active, setActive] = useState(true);

    useEffect(() => {
        LoadUnits(active)
    }, [active])

    const LoadUnits = () => {
        GetBudgetUnitTypes(active)
            .then(res => {
                setUnits(res.data)
            })
    }

    const toggleActive = () => {
        setActive(!active)
    }

    const Enable = (id, state) => {
        SetBudgetUnitTypeActive({ "budgetUnitTypeId": id, "active": state }).then(res => {
            LoadUnits(active)
        })
    }

    const Disable = (id, state) => {
        SetBudgetUnitTypeActive({ "budgetUnitTypeId": id, "active": state }).then(res => {
            LoadUnits(active)
        })
    }
    const ReorderUnit = (index, up) => {
        const currentUnits = units ?? [];

        if (index < 0 || index >= currentUnits.length) return;

        const swapWith = up ? index - 1 : index + 1;

        if (swapWith < 0 || swapWith >= currentUnits.length) return;

        const swapped = [...currentUnits];

        [swapped[index], swapped[swapWith]] = [swapped[swapWith], swapped[index]];

        const withOrder = swapped.map((u, i) => ({
            ...u,
            order: i + 1
        }));

        setUnits(withOrder)
        SetBudgetUnitTypeOrder(withOrder)
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <h3>Budget Unit Types</h3>
                </div>
            </div>

            <div className="divider my-2" />
            <div className="row">
                <div className="col-2">
                    <label>Active Only: </label>
                </div>
                <div className="col-2">
                    <div className="toggle-switch small-switch">
                        <input
                            type="checkbox"
                            className="toggle-switch-checkbox"
                            checked={active}
                            id="ToggleSwitch-Required"
                            onChange={(e) => toggleActive()}
                        />
                        <label className="toggle-switch-label" htmlFor="ToggleSwitch-Required">
                            <span className={"toggle-switch-inner"} />
                            <span
                                className={"toggle-switch-switch"}
                            />
                        </label>
                    </div>
                </div>

                <div className="col-6">
                </div>

                <div className="col-2">
                    <Button className="enc-button" as={Link} to={`${props.match.url}/new`} >Add new Unit Type</Button>
                </div>
                <div className="m-1"></div>
            </div>
            <ListGroup>
                <ListGroup.Item className="enc-data-list">
                    Units
                </ListGroup.Item>
                {units.length === 0 &&
                    <ListGroup.Item >No Budget Units Found</ListGroup.Item>
                }
                {units.map((but, i) => {
                    return (
                        <ListGroup.Item className="click-list" key={`but-${but.budgetUnitTypeId}`}>
                            <div className="row align-items-center">
                                {but.static === false &&
                                    <Link className="col-9 p2" to={`${props.match.url}/${but.budgetUnitTypeId}`}>
                                        {but.description}
                                    </Link>
                                }
                                {but.static === true &&
                                    <div className="col-9 p2">
                                        {but.description}
                                    </div>
                                }

                                <div className='col-3 list-icon-button-column'>
                                    <span className="list-icon-button">
                                        {(but.active) && <FontAwesomeIcon icon={faBan} className="clickable" onClick={() => Disable(but.budgetUnitTypeId, false)} />}
                                        {(!but.active) && <FontAwesomeIcon icon={faCheck} className="clickable" onClick={() => Enable(but.budgetUnitTypeId, true)} />}
                                    </span>
                                    <span className="list-icon-button">
                                        <FontAwesomeIcon icon={faChevronUp} className="clickable" onClick={e => ReorderUnit(i, true)} />
                                        <FontAwesomeIcon icon={faChevronDown} className="clickable" onClick={e => ReorderUnit(i, false)} />
                                    </span>
                                </div>
                            </div>
                        </ListGroup.Item>
                    )
                })}
            </ListGroup>
            <div className="m-1" />
        </div>
    )
}
